export default __webpack_public_path__ + "static/media/download.32790e4a.svg";